module.exports = __webpack_public_path__ + "static/media/vnpay-logo.be1705ac.png";